export default __webpack_public_path__ + "static/media/business-icon.bdb76025.svg";